import React, {useState} from "react";
import {withApollo} from "react-apollo";
import ActionButton from "../../../components/ActionButton";
import {GET_STOCK_TRANSFER_SHIPMENT_ADVICE} from "../../../queries/stockTransfers";

// Copy or download the transfer as a shipment advice (JSON, in the shape of the
// old advice files). Converters in hallstein_system/tools/advice-converters turn
// it into what a warehouse asks for, e.g. the Enns Excel sheet.

async function fetchAdvice(client, transferId) {
  const {data} = await client.query({
    query: GET_STOCK_TRANSFER_SHIPMENT_ADVICE,
    variables: {id: transferId},
    fetchPolicy: "network-only",
  });
  return data.stockTransfer.shipmentAdvice;
}

async function copyText(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text);
  }
  const area = document.createElement("textarea");
  area.value = text;
  document.body.appendChild(area);
  area.select();
  document.execCommand("copy");
  document.body.removeChild(area);
}

function downloadText(text, filename) {
  const url = window.URL.createObjectURL(new Blob([text], {type: "application/json"}));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

const ShipmentAdviceButtons = ({client, transferId, active}) => {
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState(false);

  const run = (action) => () => {
    setBusy(true);
    fetchAdvice(client, transferId)
      .then(action)
      .catch((error) => window.alert(`Could not get the shipment advice: ${error.message}`))
      .then(() => setBusy(false));
  };

  const copy = run((json) => copyText(json).then(() => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }));

  const download = run((json) => downloadText(json, `${transferId}.json`));

  return (
    <React.Fragment>
      <ActionButton label={copied ? "Copied" : "Copy Shipment Advice"} active={active && !busy} onClick={copy} />
      <ActionButton label="Download Shipment Advice" active={active && !busy} onClick={download} />
    </React.Fragment>
  );
};

export default withApollo(ShipmentAdviceButtons);
